export const countByStatus = (data, status) => {
	return data.reduce(
		(prev, next) => prev + (next._call_history?.status === status ? 1 : 0),
		0,
	);
};
